import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';

import { ALargeInputField } from '../../atoms';

export default function MLargeInputField({
	id,
	label,
	type,
	value,
	className,
	placeholder,
	required,
	error,
	onChange,
}) {
	return (
		<div className="m-input-field">
			<label htmlFor={id}>
				<FormattedMessage id={label} defaultMessage="" />
			</label>
			<ALargeInputField
				id={id}
				type={type}
				value={value}
				className={className}
				placeholder={placeholder}
				error={error}
				required={required}
				onChange={onChange}
			/>
		</div>
	);
}

MLargeInputField.propTypes = {
	id: PropTypes.string.isRequired,
	label: PropTypes.string.isRequired,
	value: PropTypes.string,
	type: PropTypes.string,
	className: PropTypes.string,
	placeholder: PropTypes.string,
	required: PropTypes.bool,
	error: PropTypes.bool,
	onChange: PropTypes.func,
};

MLargeInputField.defaultProps = {
	type: 'text',
	className: '',
	placeholder: '',
	value: '',
	required: false,
	error: false,
	onChange: null,
};



// WEBPACK FOOTER //
// ./src/components/molecules/fields/_molecules.large-input-field.js